import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
import axios from 'axios';
import Markdown from '../components/Markdown';
import { mensajeDeError } from '../utils/errores';

const API_BASE = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/api/v1/legal`;

/**
 * Los términos de uso y la política de privacidad, en una página pública.
 *
 * Pública a propósito: alguien tiene que poder leerlos antes de crear una
 * cuenta, y el propietario de una ferretería tiene que poder mandarle el enlace
 * a su contador sin darle acceso al sistema.
 *
 * El texto viene del backend y no está escrito acá. Es el mismo archivo contra
 * el que se registra la aceptación, de modo que no puedan separarse: una
 * pantalla con su propia copia del texto mostraría una versión y registraría
 * otra.
 */
export default function DocumentoLegal({ clave }) {
    const [documento, setDocumento] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        let vigente = true;
        setDocumento(null);
        setError('');

        axios.get(`${API_BASE}/documentos/${clave}/`)
            .then(r => { if (vigente) setDocumento(r.data); })
            .catch(e => {
                if (vigente) setError(mensajeDeError(e, 'No se pudo cargar el documento.'));
            });

        return () => { vigente = false; };
    }, [clave]);

    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <div className="max-w-3xl mx-auto px-5 py-10">
                <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-500 hover:text-slate-800 dark:text-slate-400 dark:hover:text-slate-200 mb-8">
                    <ArrowLeft size={16} />
                    Volver al inicio
                </Link>

                {error && (
                    <div className="p-4 rounded-2xl bg-error-50 dark:bg-error-950/40 ring-1 ring-error-200 dark:ring-error-800 text-sm text-error-800 dark:text-error-300">
                        {error}
                    </div>
                )}

                {!error && !documento && (
                    <p className="text-sm text-slate-500 dark:text-slate-400">Cargando el documento…</p>
                )}

                {documento && (
                    <>
                        <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wide text-slate-400 dark:text-slate-500 mb-4">
                            <FileText size={14} />
                            Versión {documento.version}
                        </div>
                        <Markdown fuente={documento.contenido} />
                    </>
                )}

                <div className="mt-12 pt-6 border-t border-slate-200 dark:border-white/10 flex gap-5 text-sm">
                    <Link to="/terminos" className="font-semibold text-brand-800 dark:text-brand-300">
                        Términos de uso
                    </Link>
                    <Link to="/privacidad" className="font-semibold text-brand-800 dark:text-brand-300">
                        Política de privacidad
                    </Link>
                </div>
            </div>
        </div>
    );
}
